import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { IStoreState } from '../../../store/modules';
import ListItem from './UserItem';

interface Props {
  onClick?: (roomId: string, type: string) => void;
}

const CenterVictim = ({ onClick }: Props) => {
  const users = useSelector((store: IStoreState) => store.MainReducer.users);
  return (
    <CenterVictimTemplateWrap>
      <HeaderText>요구조자</HeaderText>
      <ScrollWrap>
        {Array.isArray(users.vDatas) && users.vDatas.length === 0 ? (
          <EmptyText>요구조자 정보가 없습니다.</EmptyText>
        ) : (
          users.vDatas.map((item, index) => (
            <ListItemWrap key={index}>
              <ListItem
                isConnect={item.isConnect}
                name={item.name}
                phone={item.phone}
                time={item.connectTime}
                isLocation={item.isCurrentShareLocate}
                isMuted={item.isUseMic}
                useCamera={item.isLive}
                onClick={(type) => onClick && onClick(item.phone, type)}
              />
            </ListItemWrap>
          ))
        )}
      </ScrollWrap>
    </CenterVictimTemplateWrap>
  );
};

const CenterVictimTemplateWrap = styled.div`
  width: 100%;
  height: 40%;
  text-align: center;
  background: linear-gradient(180deg, #00315c 0%, #000 100%);
`;
const HeaderText = styled.h1`
  height: 40px;
  margin: auto;
  color: #fff;
  text-align: center;
  font-family: 'Noto Sans CJK KR';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  background: linear-gradient(180deg, #e63528 0%, #801d16 100%);
`;
const ScrollWrap = styled.div`
  height: calc(100% - 40px);
  overflow: auto;
`;
const ListItemWrap = styled.div``;
const EmptyText = styled.h1`
  margin-top: 40px;
  color: #fff;
  font-family: 'Noto Sans CJK KR';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
`;

export default CenterVictim;
